// DESCRIPTION: Welcome step — first screen of the wizard. Single CTA to begin
// plus a "Skip setup" escape hatch in the topbar that finalizes and exits.

import { __ } from '@wordpress/i18n';
import WizardShell from '../components/WizardShell';

/**
 * @since PBOOKING_SINCE
 *
 * @param {Object}   props
 * @param {Function} props.onStart     Begin the wizard.
 * @param {Function} props.onSkipSetup Skip the entire wizard and mark complete.
 *
 * @return {JSX.Element}
 */
export default function WelcomeStep( { onStart, onSkipSetup } ) {
	return (
		<WizardShell
			stepKey="welcome"
			onContinue={ onStart }
			continueLabel={ __( 'Get started', 'nemtly-booking' ) }
			onSkipSetup={ onSkipSetup }
		>
			<div className="nemtly-wizard-welcome">
				<h2 className="nemtly-wizard-headline">
					{ __( 'Welcome to Nemtly Booking', 'nemtly-booking' ) }
				</h2>
				<p className="nemtly-wizard-lede">
					{ __(
						'A two-minute setup gets you a working booking page with a sample event. You can refine everything later.',
						'nemtly-booking'
					) }
				</p>

				<ul className="nemtly-wizard-bullets">
					<li>
						{ __(
							'Tailored to your business type',
							'nemtly-booking'
						) }
					</li>
					<li>
						{ __(
							'Pages and a sample event ready to share',
							'nemtly-booking'
						) }
					</li>
					<li>
						{ __(
							'Stripe or offline payments — your call',
							'nemtly-booking'
						) }
					</li>
				</ul>
			</div>
		</WizardShell>
	);
}
